<template>
  <div
    class="jps-item-search-nohit is-size-6-desktop is-size-7-touch"
  >
    <slot>
      <template v-if="getMessage">
        {{ getMessage }}
      </template>
      <template v-else>
        {{ ls(dapLangGlobal.zeroHit) }}
      </template>
    </slot>
  </div>
</template>

<script lang="ts" setup>
import { dapLangGlobal } from '#imports'
const { ls } = useI18n()

interface Props {
  message?: string
}
const props = withDefaults(defineProps<Props>(), {})

const getMessage = computed(() => {
  if (isEmpty(props.message)) {
    return null
  }
  return ls(dapLangGlobal.message[props.message])
})

</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-item-search-nohit {
  margin: 1rem 0;
  text-align: center;

  @include is-tablet {
    width: 32rem;
    margin: 0 auto;
    padding: 1rem;
    border: 1px solid $jps-gray-300;
    border-radius: 0.5rem;
  }
}
</style>
